// src/store/slices/educationSlice.ts
import { createGenericSlice } from './genericSliceFactory';
import type { Education } from '@/types';

const educationSlice = createGenericSlice<Education>({
    name: 'educations',
    endpoint: '/educations',
});

export const {
    setCurrentItem: setCurrentEducation,
    clearError,
    setSelectedIds,
    toggleSelectId,
    clearSelectedIds,
} = educationSlice.actions;

export const {
    fetchActive: fetchActiveEducations,
} = educationSlice.thunks;

export default educationSlice.reducer;
